import { getIsBundleBbJsw, Url } from '@atlassiansox/bxpkit-core';
import React from 'react';
import { SideInfoOptionsType } from '../../../../../model';
import { useSignUpFormConfig } from '../../../../../hook';
import {
  Layout,
  SideInformationComponent
} from '../../side-information-component';
import {
  FREE_EDITION_LABEL_KEY,
  getEditionLabels,
  getFeaturesList,
  getSideInfoHeader,
  getTrialDurationExistingSiteLabel,
  getTrialDurationNewSiteLabel
} from '../../utility/sign-up-layout-container';

/**
 * Obtain required data (aside from what's provided
 * by props), & render side-information-component component
 */

export function SideInfo({
  labels,
  userInfo,
  productKeys,
  analyticsTrack,
  migrationData,
  isMigrationSignup,
  formExistingSiteShown
}: SideInfoOptionsType) {
  let layout: Layout = 'default';

  const queryParameters = Url.getUrlParams() || {};
  const developerMode = queryParameters.hasOwnProperty('developer');
  const sideInfoHeaderLabel = getSideInfoHeader({
    labels,
    productKeys,
    developerMode
  });
  // currently, only BB/JSW bundle is a devops layout
  if (getIsBundleBbJsw(productKeys)) {
    layout = 'devops';
  }

  if (developerMode) {
    layout = 'developer-mode';
  }

  const { edition: editionOverride } = useSignUpFormConfig();

  const sanitizedProps = productKeys.map((product) => {
    const { product: productKey, imgSource = '', edition } = product;
    const { editionLabel } = getEditionLabels({
      productKey,
      edition: editionOverride ? editionOverride : edition
    });
    const isFree = product.edition === FREE_EDITION_LABEL_KEY.toLowerCase();
    const trialDurationExistingSiteLabel =
      isFree || migrationData
        ? ''
        : getTrialDurationExistingSiteLabel({ productKey, labels });
    const trialDurationNewSiteLabel =
      isFree || migrationData
        ? ''
        : getTrialDurationNewSiteLabel({ productKey, labels });
    const isExistingFormShown = formExistingSiteShown
      ? !!(userInfo && userInfo.email)
      : formExistingSiteShown;

    // setting featuresListEditionLabelKey to 'free' to fix BXPSU-348.
    // forcing the edition to 'free' at this getFeaturesList() call
    //   makes feature list copy the same for all editions in the "default"
    //   sign up layout.
    const featuresList = getFeaturesList({
      labels,
      productKey,
      products: productKeys,
      featuresListEditionLabelKey: 'free',
      migrationData,
      developerMode
    });

    return {
      layout,
      isLoading: isMigrationSignup && !migrationData,
      imgSource,
      edition: editionLabel,
      featuresList,
      sideInfoHeader: sideInfoHeaderLabel,
      trialDurationExistingSite: trialDurationExistingSiteLabel,
      trialDurationNewSite: trialDurationNewSiteLabel,
      isExistingSiteFormShown: isExistingFormShown,
      productKeys,
      key: productKey,
      analyticsTrack,
      isMobile: false
    };
  });

  return <SideInformationComponent {...sanitizedProps[0]} />;
}
